import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingPhotos = createSelector(coworkingSelector, coworking => coworking?.photos || []);
